import { BorderedCard } from '@aibees/shared/components';
import { AdvanceTable } from '@aibees/shared/features';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(BorderedCard)`
  padding: ${(p) => p.theme.spacing(1)};
  border-radius: 0.5;
  border-color: ${(p) => p.theme.palette.grey[400]};
  box-shadow: none;
`;

export const Table = styled(AdvanceTable)`
  padding: 0;
  padding-bottom: ${(p) => p.theme.spacing(2)};
  background-color: ${(p) => p.theme.palette.common.white};

  max-width: 100%;
  table {
    width: 100%;
    td,
    th {
      text-overflow: hidden;
      white-space: nowrap;
      padding: 0 16px;
      overflow: hidden;
    }
    th {
      width: fit-content !important;
    }
  }
  thead {
    height: 40px;
  }
  tr {
    height: 38px;
  }
  th:hover {
    span {
      color: ${(p) => p.theme.palette.common.black};
    }
  }

  .Table {
    background-color: ${(p) => p.theme.palette.common.white};
    border-radius: ${(p) => p.theme.spacing(1)};
    border: 1px solid ${(p) => p.theme.palette.grey[300]};
  }

  tr:last-child {
    td {
      border-bottom-width: 0 !important;
    }
  }

  tr {
    background-color: ${(p) => p.theme.palette.common.white};
  }

  tr:hover {
    background: ${(p) => p.theme.palette.primary[50]};
  }
`;
